import * as React from "react";
import { cn } from "src/util/cn";


const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    withHover?: boolean;
    hoverAlways?: boolean;
    hoverColour?:
      | "green"
      | "red"
      | "orange"
      | "img-green"
      | "img-yellow"
      | "purple";
    hoverDirections?: "down" | "up";
    maxWidth?: "sm" | "md" | "lg";
    padding?: "default" | "large" | "none";
  }
>(
  (
    {
      className,
      withHover,
      hoverAlways,
      hoverDirections = "down",
      hoverColour = "green",
      maxWidth,
      padding = "default",

      ...props
    },
    ref
  ) => (
    <div
      ref={ref}
      data-with-hover={withHover}
      data-hover-always={hoverAlways}
      data-hover-colour={hoverColour}
      data-hover-direction={hoverDirections}
      className={cn(
        "rounded bg-card ",
        maxWidth === "sm" && "max-w-[400px]",
        maxWidth === "md" && "max-w-[600px]",
        maxWidth === "lg" && "max-w-[1024px]",

        padding === "default" && "p-3 pt-[22px] lg:p-6",
        padding === "large" && "p-10 md:pt-[82px] md:pb-[70px]",
        padding === "none" && "p-0",
        className
      )}
      {...props}
    />
  )
);

const CardListWrapper = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { spacedOut?: boolean }
>(({ className, spacedOut, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "",
      spacedOut ? "grid gap-[7px]" : "bg-gray-90 rounded",
      className
    )}
    {...props}
  />
));

const CardListItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { spacedOut?: boolean }
>(({ className, spacedOut, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "p-2 px-[14px] min-h-11 lg:min-h-[52px] flex border-[2px] border-gray-90 rounded active:bg-background lg:hover:bg-background has-[:focus]:bg-background",
      spacedOut ? "bg-gray-90" : "",
      className
    )}
    {...props}
  />
));

export const CardListRenderer = ({
  data,
  className,
}: {
  data: { [key: string]: string | React.ReactNode };
  className?: string;
}) => (
  <CardListWrapper className={cn("text-[14px] lg:text-sm", className)}>
    {Object.entries(data).map(([key, value]) => (
      <CardListItem key={key} className="flex justify-between items-center">
        <p className=" text-gray-60">{key}</p>
        <p>{value}</p>
      </CardListItem>
    ))}
  </CardListWrapper>
);

Card.displayName = "Card";
CardListWrapper.displayName = "CardListWrapper";
CardListItem.displayName = "CardListItem";

export { Card, CardListWrapper, CardListItem };
